export interface State {
  inProgress: boolean
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    inProgress: false,
  }
}
